<template>
    <div class="side-bar-mobile mobile" @click="showDropdown = false">



        <!-- ปุ่มเปิดเมนู (MOBILE) -->
        <button class="menu-button  w-100" @click="showMobileMenu = !showMobileMenu">

            <span class="material-symbols-outlined">
                {{ showMobileMenu ? "close" : "menu" }}
            </span>
            เมนูเพิ่มเติม
        </button>

        <!-- MOBILE MENU (BOTTOM SHEET STYLE) -->
        <transition name="slide">
            <div v-if="showMobileMenu" class="sidebar-mobile-sheet">

                <!-- ✅ แก้ — เดิมมีแค่ 5 เมนู (chat/comment/ads/package/logs) หายไป 6 เมนูเทียบกับ
                     Sidebar.vue เวอร์ชันเดสก์ท็อป รวมถึง "ออเดอร์" กับ "คลังสินค้า" ที่เป็น flagship
                     feature — ผู้ใช้มือถือเข้าไม่ถึงฟีเจอร์หลักของธุรกิจเลย นี่คือสาเหตุหลักที่ทำให้
                     รู้สึกว่า "sidebar หายไป" ตอนสลับเป็นโหมดมือถือ — เปลี่ยนมาใช้ menuGroups (computed
                     ด้านล่าง) เหมือน Sidebar.vue เป๊ะ วนด้วย v-for แทนการ copy เมนูมาแปะทีละอันเหมือนเดิม
                     กันสองไฟล์นี้เมนูไม่ตรงกันอีกในอนาคต (ยัง duplicate logic กันอยู่ระหว่างสองไฟล์
                     เพราะยังไม่อยากรื้อโครงสร้าง component ใหญ่เกินความจำเป็นของงานนี้ — ถ้าจะทำให้ดี
                     กว่านี้ในอนาคต ควรย้าย menuGroups ไปไว้ composable/mixin ที่ใช้ร่วมกันทั้งสองไฟล์) -->
                <nav class="mt-6 gap-2">
                    <div v-for="group in menuGroups" :key="group.label" class="mobile-nav-group">
                        <div class="mobile-nav-group-label">{{ group.label }}</div>
                        <ul class="space-y-1">
                            <li v-for="item in group.items" :key="item.name">
                                <button
                                    class="btn menu-btn"
                                    :class="{ active: $route.name === item.name }"
                                    @click="go(item.path)"
                                >
                                    <span class="material-symbols-outlined">{{ item.icon }}</span>
                                    {{ item.label }}
                                </button>
                            </li>
                        </ul>
                    </div>
                </nav>

            </div>
        </transition>


    </div>
</template>

<script>
import emitter from '../helpers/eventBus';
import CreditCard from '../components/CreditCard'
import PackageCardTooltip from '../components/PackageCardTooltip'

export default {
    name: "SidebarMenu",
    components: { CreditCard, PackageCardTooltip },
    computed: {
        appName() {
            return process.env.VUE_APP_NAME || 'MyApp'
        },
        pageInfo() {
            return this.$storex.getters["pageModule/getPageInfo"];
        },
        subscription() {
            return this.$storex.getters["subscriptionModule/getSubscription"];
        },
        // ✅ ใหม่ — เหมือน Sidebar.vue เป๊ะ (ดู comment ที่นั่น) — duplicate ไว้ที่นี่เพราะ SidebarMobile
        // เป็นคนละ component ไม่ได้ extend จาก Sidebar.vue กัน ถ้าแก้เมนูฝั่งเดสก์ท็อป ต้องแก้ที่นี่คู่กัน
        // ด้วยเสมอ (ไม่มี compiler เตือนให้ ต้องจำเอง — ความเสี่ยงเดิมที่ทำให้เกิดปัญหานี้ตั้งแต่แรก)
        pageId() {
            return this.$route.params.id;
        },
        menuGroups() {
            const id = this.pageId;
            const marketplaceItems = [
                { name: 'dashboard-order', label: 'ออเดอร์', icon: 'shopping_cart', path: `/dashboard/${id}/order` },
                { name: 'dashboard-customers', label: 'ลูกค้า', icon: 'group', path: `/dashboard/${id}/customers` }, // ✅ ใหม่
                { name: 'dashboard-stock', label: 'คลังสินค้า', icon: 'inventory_2', path: `/dashboard/${id}/stock` },
            ];
            if (this.dineInEnabled) {
                marketplaceItems.push({ name: 'dashboard-dine-in', label: 'สั่งหน้าร้าน', icon: 'table_restaurant', path: `/dashboard/${id}/dine-in` });
            }
            return [
                {
                    label: 'ภาพรวม',
                    items: [
                        { name: 'dashboard-home', label: 'หน้าแรก', icon: 'space_dashboard', path: `/dashboard/${id}/home` },
                    ],
                },
                {
                    label: 'มาร์เก็ตเพลส',
                    items: marketplaceItems,
                },
                {
                    label: 'AI Automation',
                    items: [
                        { name: 'dashboard-health', label: 'ตรวจสุขภาพเพจ', icon: 'health_metrics', path: `/dashboard/${id}/health` },
                        { name: 'dashboard-chat', label: 'จัดการข้อความ', icon: 'chat_bubble', path: `/dashboard/${id}/chat` },
                        { name: 'dashboard-comment', label: 'จัดการคอมเมนต์', icon: 'comment', path: `/dashboard/${id}/comment` },
                        { name: 'dashboard-instagram-comments', label: 'Instagram Comments', icon: 'forum', path: `/dashboard/${id}/instagram-comments` },
                        { name: 'dashboard-post', label: 'สร้างคอนเทนต์', icon: 'edit_note', path: `/dashboard/${id}/post` },
                        { name: 'dashboard-ads', label: 'Ads Draft Builder', icon: 'campaign', path: `/dashboard/${id}/ads` },
                    ],
                },
                {
                    label: 'บัญชี',
                    items: [
                        { name: 'dashboard-package', label: 'แพ็กเกจ', icon: 'inventory', path: `/dashboard/${id}/package` },
                        { name: 'dashboard-logs', label: 'ประวัติการใช้งาน', icon: 'schedule', path: `/dashboard/${id}/logs` },
                        { name: 'dashboard-guide', label: 'คู่มือการใช้งาน', icon: 'menu_book', path: `/dashboard/${id}/guide` },
                    ],
                },
            ];
        },
    },

    data() {
        return {
            showDropdown: false,
            showPackage: false,
            hoverMessage: false,
            showMobileMenu: false,
            // ✅ ใหม่ — เหมือน Sidebar.vue เป๊ะ
            dineInEnabled: false,
            packageInfo: {
                name: "Starter Plan",
                used: 1,
                limit: 10,
            },
        };
    },
    async mounted() {
        window.addEventListener("mousedown", this.handleClickOutside);
        // ✅ ใหม่ — เหมือน Sidebar.vue เป๊ะ
        await this.loadDineInSettings();
    },
    beforeUnmount() {
        window.removeEventListener("mousedown", this.handleClickOutside);
    },
    watch: {
        // ✅ ใหม่ — เหมือน Sidebar.vue เป๊ะ (ดู comment ที่นั่น — sidebar mount ค้างไว้ตลอด pageId
        // เปลี่ยนได้ถ้าสลับเพจ)
        pageId() {
            this.loadDineInSettings();
        },
    },
    methods: {
        // ✅ ใหม่ — เหมือน Sidebar.vue เป๊ะ
        async loadDineInSettings() {
            if (!this.pageId) return;
            try {
                const res = await this.$http.get(`${process.env.VUE_APP_BACKEND_URL}/api/pages/${this.pageId}/dine-in/settings`);
                this.dineInEnabled = !!res.data.settings?.enabled;
            } catch (err) {
                console.error('SidebarMobile loadDineInSettings error:', err);
                this.dineInEnabled = false;
            }
        },
        // ✅ ใหม่ — ปิด bottom sheet อัตโนมัติทุกครั้งที่กดเมนู (เดิม @click="$router.push(...)" ตรงๆ
        // ไม่ได้ปิด sheet ทันที ต้องรอ route เปลี่ยนแล้ว component unmount/re-render ถึงจะหายไปเอง —
        // แก้ให้ปิดทันทีเป็น UX ที่คาดหวังปกติของ bottom sheet menu)
        go(path) {
            this.showMobileMenu = false;
            if (this.$route.path === path) return;
            this.$router.push(path);
        },
        handleClickOutside(event) {
            if (!this.$el.contains(event.target)) {
                this.showDropdown = false;
            }
        },
        handleDelete() {
            emitter.emit('deleteDocument');
        },
        handleSave() {
            emitter.emit('saveDocument');
        },
        goUpgrade() {
            this.$router.push('/upgrade');
        },
        goBack() {
            try {
                this.$store.dispatch("pageModule/removePageInfo");

                this.$store.dispatch('removePageData');

                this.$router.push('/');

            } catch (error) {
                console.log(error)
            }

        }
    },

};

</script>

<style scoped>
.profile {
    border: 1px solid var(--gray-1);
    border-radius: 50px;
    padding: 0.2em 0.3em;
}

.btn-start {
    background: #111;
    color: #fff;
    font-size: 1rem;
    font-weight: 500;
    border-radius: 50px;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
}

.btn-start:hover {
    background: #333;
    color: #fff;
    transform: translateY(-2px);
}

.credit-button {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    color: #111827;
    border-radius: 9999px;
    padding: 0.45rem 1rem;
    font-size: 0.85rem;
    font-weight: 500;
    text-decoration: none;
    transition: all 0.25s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
}

.credit-button:hover {
    background: #2563eb;
    color: #fff;
    border-color: #2563eb;
    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.25);
    transform: translateY(-1px);
}

.credit-inner {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    transition: color 0.3s ease, transform 0.2s ease;
}

.credit-inner span {
    transition: all 0.25s ease;
}

.credit-inner .material-symbols-outlined {
    font-size: 18px;
}

.side-bar-mobile {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    padding: 12px 16px;
    border-bottom: 1px solid #eee;
    position: fixed;
    bottom: 0;
    z-index: 20;
    width: 100%;
    /* กันปุ่มชนแถบ home indicator ของ iPhone */
    padding-bottom: calc(12px + env(safe-area-inset-bottom, 0px));
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.06);
}

/* APP NAME */
.left-area {
    display: flex;
    align-items: center;
    gap: 6px;
}

.app-name {
    font-size: 1.1rem;
    font-weight: 700;
    color: #111;
    text-decoration: none;
}

.badge-beta {
    background: #111;
    color: #fff;
    font-size: 8px;
    padding: 2px 6px;
    border-radius: 6px;
}

/* PROFILE */
.profile-area {
    position: relative;
}

.profile-img {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    cursor: pointer;
}

.dropdown-menu {
    position: absolute;
    right: 0;
    top: 44px;
    background: #fff;
    border-radius: 12px;
    border: 1px solid #ddd;
    width: 150px;
    padding: 6px 0;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
    animation: fadeIn 0.2s;
}

/* BUTTON: MOBILE MENU */
.menu-button {
    display: none;
    background: #111;
    color: #fff;
    padding: 10px 14px;
    min-height: 44px;
    justify-content: center;
    gap: 8px;
    border-radius: 12px;
    border: none;
    font-weight: 600;
}

.notmobile {
    display: flex !important
}

.mobile {
    display: none !important
}

@media (max-width: 1250px) {
    .menu-button {
        display: flex;
        align-items: center;
    }

    .notmobile {
        display: none !important
    }

    .mobile {
        display: flex !important
    }
}

/* SHEET MENU */
.sidebar-mobile-sheet {
    position: fixed;
    bottom: calc(68px + env(safe-area-inset-bottom, 0px));
    left: 0;
    right: 0;
    z-index: 19;
    /* เมนูมี 10+ รายการ — จอเตี้ยต้องเลื่อนในตัวเองได้ ไม่งั้นรายการบนสุดหลุดจอ */
    max-height: calc(100dvh - var(--pr-topbar-h, 68px) - 68px - env(safe-area-inset-bottom, 0px) - 12px);
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    background: #fff;
    padding: 18px;
    border-radius: 20px 20px 0 0;
    box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.15);
    animation: slideUp 0.25s ease-out;
}

.sheet-section {
    margin-bottom: 14px;
}

.sheet-btn {
    width: 100%;
    padding: 14px;
    background: #f7f7f7;
    border-radius: 14px;
    border: 1px solid #ddd;
    font-size: 1rem;
    display: flex;
    align-items: center;
    gap: 10px;
    color: #111;
    text-decoration: none;
}

.sheet-btn:hover {
    background: #efefef;
}

/* ✅ ใหม่ — .menu-btn ถูกใช้ใน template แต่ไม่เคยมี CSS รองรับเลยตั้งแต่แรก (ปุ่มเมนูใน bottom sheet
   เลยแสดงผลแบบไม่มีสไตล์ ไอคอนไม่จัดแนว ไม่มีสีบอกสถานะ active) — ออกแบบให้กลืนกับ Sidebar.vue
   เวอร์ชันเดสก์ท็อป (.pr-nav-item) เพื่อความสม่ำเสมอของ UI ทั้งสองโหมด */
.mobile-nav-group {
    margin-bottom: 18px;
}

.mobile-nav-group:last-child {
    margin-bottom: 0;
}

.mobile-nav-group-label {
    font-size: 0.68rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #9090a0;
    padding: 0 4px 8px;
}

.menu-btn {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
    border: none;
    background: transparent;
    color: #52525e;
    font-size: 0.92rem;
    font-weight: 500;
    padding: 12px 10px;
    min-height: 44px;
    border-radius: 10px;
    cursor: pointer;
    text-align: left;
    transition: background 0.15s ease, color 0.15s ease;
}

.menu-btn .material-symbols-outlined {
    font-size: 20px;
    color: #9090a0;
    transition: color 0.15s ease;
    flex-shrink: 0;
}

.menu-btn:hover {
    background: #f8f8fc;
}

.menu-btn.active {
    background: linear-gradient(135deg, rgba(13, 13, 18, 0.10), rgba(37, 99, 235, 0.10));
    color: var(--pr-indigo);
    font-weight: 700;
}

.menu-btn.active .material-symbols-outlined {
    color: var(--pr-indigo);
}

/* Avatar mini */
.avatar-mini {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    margin-left: auto;
}

/* ANIMATION */
@keyframes slideUp {
    from {
        transform: translateY(30px);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

.slide-enter-active,
.slide-leave-active {
    transition: all 0.25s;
}

.slide-enter-from,
.slide-leave-to {
    transform: translateY(20px);
    opacity: 0;
}
</style>